<template>
    <div class="fromtable">
        <el-form :model="numberValidateForm" :rules="rules" ref="numberValidateForm" label-position='left'
            class="Myfrom">
            <!-- 验证名字是否填写 -->
            <el-form-item label="" prop="name" class="name">
                <el-input placeholder="姓名" v-model="numberValidateForm.name" prefix-icon='el-icon-user-solid'></el-input>
            </el-form-item>
            <!-- 验证公司是否填写 -->
            <el-form-item label="" prop="company" class="company">
                <el-input placeholder="公司" v-model="numberValidateForm.company" prefix-icon='el-icon-s-platform'></el-input>
            </el-form-item>
            <!-- 验证邮箱类型 -->
            <el-form-item label="" prop="email" class="email">
                <el-input type="email" placeholder="邮箱" v-model="numberValidateForm.email" autocomplete="off" prefix-icon='el-icon-chat-square'>
                </el-input>
            </el-form-item>
            <!-- 验证手机类型 -->
            <el-form-item label="" prop="phone" class="tel">
                <el-input placeholder="电话" v-model.number="numberValidateForm.phone" autocomplete="off" prefix-icon='el-icon-phone'>
                </el-input>
            </el-form-item>
            <h3 class="neddscaption">描述您的需求:</h3>
            <!-- 留言区域 -->
            <el-form-item label="" prop="demandContent" class="needs">
                <el-input type="textarea" :autosize="{ minRows: 8}" placeholder="..."
                    v-model="numberValidateForm.demandContent">
                </el-input>
            </el-form-item>
            <div class="subMit" @click="submitForm('numberValidateForm')">{{msg}}</div>
        </el-form>
    </div>
</template>
<script>
    export default {
        name: 'From',
        data() {
            return {
                // 表单的内容双绑定
                numberValidateForm: {
                    email: '',//邮箱
                    name: '',//客户名称
                    phone: '',//客户电话
                    company: '',//公司名称
                    demandContent: ''//客户留言
                },
                //表单验证规则
                rules: {
                    name: [//名字验证规则
                        { required: true, message: '名字不能为空', trigger: 'blur' },
                        { min: 1, message: '请输入不少于1个字符', trigger: 'blur' }
                    ],
                    company: [//公司验证规则
                        { required: true, message: '公司不能为空', trigger: 'blur' },
                        { min: 3, message: '请输入不少于3个字符', trigger: 'blur' }
                    ],
                    email: [//邮箱验证规则
                        { required: true, message: '邮箱不能为空', trigger: 'blur' },
                        { type: 'email', message: '请核对您的邮箱是否正确', trigger: ['blur', 'change'] }
                    ],
                    phone: [//手机验证规则
                        { required: true, message: '手机不能为空', trigger: 'blur' },
                        { type: 'number', message: '请核对您的手机是否正确', trigger: ['blur', 'change'] }
                    ],
                    demandContent: [//验证客户需求
                        { required: true, message: '请填写您想要咨询的问题', trigger: 'blur' },
                    ]
                },
                //按钮的内容文案
                msg: '提交',

            }
        },
        //方法
        methods: {
            submitForm(formName) {//提交方法
                let _this = this
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.upFrom()
                    } else {
                        return false;
                    }
                    // valid&&this.upFrom()
                });
            },
            clearFrom() {
                for (let i in this.numberValidateForm) {
                    this.numberValidateForm[i] = ''
                }
                return
            },
            upFrom() {//上传表单内容
                this.$message.success('表单正在上传中，请稍后')
                let fromData = new FormData()
                for (let i in this.numberValidateForm) {
                    fromData.set(i, this.numberValidateForm[i])
                }
                this.$axios.post(this.$API.demands, fromData).then(res => {
                    this.clearFrom()
                    // window.location.href = `/thank`
                }).catch(err => {
                    this.$message.error('访问断开，请尝试重试')
                })
            }
        }
    }
</script>
<style scoped>
    .download {
        display: none;
    }

    .spanfont {
        color: #8492a6;
    }

    /* =========================================grid-item样式================================= */
    .name {
        grid-area: Name;
    }

    .company {
        grid-area: Company;
    }

    .email {
        grid-area: Email;
    }

    .tel {
        grid-area: Tel;
    }

    .needs {
        grid-area: DemandContent;
    }

    .subMit {
        grid-area: Submit;
    }

    .neddscaption {
        grid-area: Captiond;
        font-size: 16px;
        font-weight: 400;
        line-height: 375%;
        color: rgba(28, 28, 28, 1);
    }
</style>


// WEBPACK FOOTER //
// src/components/base/fromtable.vue